/*
 * @Author: your name
 * @Date: 2021-08-23 20:43:12
 * @LastEditTime: 2022-02-15 10:31:48
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\Login\LoginFeishu\index.jsx
 */
import React, { Component } from 'react';
import LoginThirdBtn from "../LoginThirdBtn";
import LoginAccountInput from "../LoginAccountInput";
import LoginQYZJWechatCode from "../LoginQYZJWechatCode";
import BsyBtn from "../BsyBtn";
import tipAlert from "../BsyAlertTip/Staticize";
import { BsyUtils } from '../../utils/Utils';

import './index.css'

class LoginQYZJwechat extends Component {
    state = {
        phoneError: false,
        dingdingTeamList: [],
        dingdingTeamUrl: '',
        phone: ''
    }
    gotoFeishuLogin = () => {
        const {phone} = this.state;
        if(phone){
            React.axios('/qyweixin/login',{mobile:phone}).then((res)=>{
                if(res.data.data.length > 1){
                    this.setState({
                        dingdingTeamList:res.data.data
                    })
                }else if(res.data.data.length === 1){
                    window.open(res.data.data[0].login_url)
                }else if(res.data.data.length === 0){
                    tipAlert({
                        type: 'warning',
                        msg: React.language('error.1010')
                    })
                }
            })
        }
        
    }

    changePhone = (event) => {
        const { value } = event.target;

        this.setState({
            phone: value,
            phoneError: false
        })
    }

    phoneValue = (rel) => {
        this.getPhone = rel
    }

    selectTeam = (url) => {
        return (event) => {
            for(var i = 0; i<event.target.parentNode.childNodes.length;i++){
                event.target.parentNode.childNodes[i].classList.remove("select")
            }
            event.target.classList.add("select")
            this.setState({
                dingdingTeamUrl: url
            })
        }
    }

    openUrl = () =>{
        const {dingdingTeamUrl} = this.state;
        if(dingdingTeamUrl){
            BsyUtils.redirectTo(dingdingTeamUrl, '_blank')
        }else{
            tipAlert({
                type: 'warning',
                msg: React.language('qywechat.bind.select.user')
            })
        }
    }

    render() {
        const { changeContModePage, customLoginConfig } = this.props;
        const { phoneError, phone, dingdingTeamList } = this.state;
        const modeBtnShow = {
            dingdingShow: true,
            workWechatShow: true,
            feishuShow: true,
            qyWechatShow: true,
            qyzjWechatShow: false,
            wechatShow: true,
            LoginAccountPasswordShow: true,
            LoginCodeShow: true,
            ssoShow: true,
        }

        return (
            <div className="LoginZJWorkWechat">

                {dingdingTeamList.length <= 1 ? <>
                    <div className="loginContentBox">
                        <LoginQYZJWechatCode />
                    </div>
                    <LoginThirdBtn modeBtnShow={modeBtnShow} customLoginConfig={customLoginConfig} changeContModePage={changeContModePage} />
                </> : <div className="dingding-more-teams">
                    <div className="more-teams-title">
                        <p>
                            {React.language('dingding.have.teams.tip')}
                        </p>
                    </div>
                    <div className="more-teams-list">
                        <ul>
                            {
                                dingdingTeamList.map((val) => {
                                    return <li className="item" onClick={this.selectTeam(val.login_url)}>{val.team_name}</li>
                                })
                            }
                        </ul>
                    </div>
                    <div onClick={this.openUrl} className="m-dingding-teamsNext-btn">
                        {React.language('nextStep')}
                    </div>
                </div>}
            </div>
        );
    }
}

export default LoginQYZJwechat;